// import * as firebase from "firebase/app";
// import 'firebase/firestore'

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyC8Yb45f3suXbaMFOnak9if7062WRs-h4s",
  authDomain: "sdoh-d42df.firebaseapp.com",
  databaseURL: "https://sdoh-d42df.firebaseio.com",
  projectId: "sdoh-d42df",
  storageBucket: "sdoh-d42df.appspot.com",
  messagingSenderId: "963007919921",
  appId: "1:963007919921:web:b9a6246439613f915da210"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
